import { configureStore } from '@reduxjs/toolkit';
import authSlice from './slices/authSlice';
import uiSlice from './slices/uiSlice';
import conversationsSlice from './slices/conversationsSlice';
import messagesSlice from './slices/messagesSlice';
import contactsSlice from './slices/contactsSlice';
import crmSlice from './slices/crmSlice';
import campaignsSlice from './slices/campaignsSlice';
import channelsSlice from './slices/channelsSlice';
import analyticsSlice from './slices/analyticsSlice';

export const store = configureStore({
  reducer: {
    auth: authSlice,
    ui: uiSlice,
    conversations: conversationsSlice,
    messages: messagesSlice,
    contacts: contactsSlice,
    crm: crmSlice,
    campaigns: campaignsSlice,
    channels: channelsSlice,
    analytics: analyticsSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store; 